
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as errori9Edg0gghXES6Im9jgtQRuRuDxmZRKhNjxjv_sKe1sIMeta } from "/opt/build/repo/website/core/pages/error.vue?macro=true";
import { default as indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta } from "/opt/build/repo/website/main/pages/index.vue?macro=true";
import { default as indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta } from "/opt/build/repo/website/main/pages/about/index.vue?macro=true";
import { default as indexqhgk_MXHaZ_45704N5KFxo4GmyVqhZK1YMg4piqSGXshsMeta } from "/opt/build/repo/website/main/pages/legal/index.vue?macro=true";
import { default as _91slug_93tHKSCvlj84AKcYcYZLhva_4qizeTO2iMZ3DNhV06K8AMeta } from "/opt/build/repo/website/main/pages/about/[slug].vue?macro=true";
import { default as indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta } from "/opt/build/repo/website/main/pages/giving/index.vue?macro=true";
import { default as _91slug_93tEl1sNKcyzbOjQeV4Al_4577aGgDtgo_45CHFlBMXAJeTOgMeta } from "/opt/build/repo/website/main/pages/legal/[slug].vue?macro=true";
import { default as indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta } from "/opt/build/repo/website/main/pages/uplift/index.vue?macro=true";
import { default as indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta } from "/opt/build/repo/website/main/pages/capital/index.vue?macro=true";
import { default as indexM7S65CRSCk2CnoO07woFqOM1giNVG_ZdSCmtCuuHbrAMeta } from "/opt/build/repo/website/main/pages/contact/index.vue?macro=true";
import { default as indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta } from "/opt/build/repo/website/main/pages/issuing/index.vue?macro=true";
import { default as indexqdMcnRtFeekfd8FGjkyndahC865KQkNfmIP5LvahDuQMeta } from "/opt/build/repo/website/main/pages/offices/index.vue?macro=true";
import { default as indext_AK4TLuinSt3RJIcpiPipSJ2E8OWwXwNn5cWWF7Jm8Meta } from "/opt/build/repo/website/main/pages/payouts/index.vue?macro=true";
import { default as indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta } from "/opt/build/repo/website/main/pages/plugins/index.vue?macro=true";
import { default as _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta } from "/opt/build/repo/website/main/pages/uplift/[slug].vue?macro=true";
import { default as indexXAomI_Jimm8rQcFoCWMQviElK4pR1BzN_45p4fRQuB1sUMeta } from "/opt/build/repo/website/main/pages/accounts/index.vue?macro=true";
import { default as _91slug_93MLSm3R1tFocwmuYQ66Q5wB9QnhfKJhRKqoMKk_45nXLPgMeta } from "/opt/build/repo/website/main/pages/contact/[slug].vue?macro=true";
import { default as indexThMiG8F0sdxwboAaQdAsSYXLsc2IjI9BYMiJpFEsvhsMeta } from "/opt/build/repo/website/main/pages/licenses/index.vue?macro=true";
import { default as indexqeP61WA697p86K8eN41VrVjciWqm8lV3AzMZV7GyOuUMeta } from "/opt/build/repo/website/main/pages/partners/index.vue?macro=true";
import { default as indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta } from "/opt/build/repo/website/main/pages/customers/index.vue?macro=true";
import { default as _91slug_93QSq8Vqn8fr_45fATNqsx7MP4ODpbCjpdfw1I1udwRN2gwMeta } from "/opt/build/repo/website/main/pages/licenses/[slug].vue?macro=true";
import { default as _91slug_93eVUfHGCD_45Z4u1d1aH7ZPlm80MAt8vvMHgKaqzo2duQ0Meta } from "/opt/build/repo/website/main/pages/partners/[slug].vue?macro=true";
import { default as indexjzlJGX8E_r0blxR_5pHvWmQxuL4B2j5xhDfzu7ybmkIMeta } from "/opt/build/repo/website/main/pages/industries/index.vue?macro=true";
import { default as indexQK8EJ_45ElY1bloy3nvVKBW2LTpTIQVluFaTjABWPZDRIMeta } from "/opt/build/repo/website/main/pages/the-latest/index.vue?macro=true";
import { default as indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta } from "/opt/build/repo/website/main/pages/pay-by-link/index.vue?macro=true";
import { default as _91slug_93Hid_Mkvr014heu6MYhGcifeNPGZq_45HouM9E2EBmLokgMeta } from "/opt/build/repo/website/main/pages/the-latest/[slug].vue?macro=true";
import { default as indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta } from "/opt/build/repo/website/main/pages/pos-payments/index.vue?macro=true";
import { default as indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta } from "/opt/build/repo/website/main/pages/web-payments/index.vue?macro=true";
import { default as indexfHRIAxS6UwleDwmS4yd3bSsaG1T_fVPUE4mKPh18_4500Meta } from "/opt/build/repo/website/main/pages/customer-area/index.vue?macro=true";
import { default as indexka32KB_45Y3vS_45vDLQHTNG6xOo1xEh4tOztFoSgw8mvp0Meta } from "/opt/build/repo/website/main/pages/index-reports/index.vue?macro=true";
import { default as _91slug_93r5dNTl1atb7p5T_0SlHI27O46_Rfv8tFZULnYBZsLlYMeta } from "/opt/build/repo/website/main/pages/index-reports/[slug].vue?macro=true";
import { default as indexJFg_45JbNEbEcb7aNVd54gsPahcgIB7kSeiiSmJjzWzD0Meta } from "/opt/build/repo/website/main/pages/infrastructure/index.vue?macro=true";
import { default as indexbGZKb6CT8oqPXVGCBHyltTh7TOmRMZ3yu5rUau6KhAYMeta } from "/opt/build/repo/website/main/pages/privacy-policy/index.vue?macro=true";
import { default as indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta } from "/opt/build/repo/website/main/pages/accept-payments/index.vue?macro=true";
import { default as indexdMa56kvIBOADFQ5JtxKqQILfbPz2tVCDV9pIBE_jTDEMeta } from "/opt/build/repo/website/main/pages/online-payments/index.vue?macro=true";
import { default as _91slug_93EBTqaJ_xmhMPaTDau0G_jY5SanSUMt6ALv1R3Da0KREMeta } from "/opt/build/repo/website/main/pages/privacy-policy/[slug].vue?macro=true";
import { default as indexBxXKwp0_45hGyz50jAGh4_uR4MHgxv7MAwd1ilfW8DpYMMeta } from "/opt/build/repo/website/main/pages/giving/nonprofit/index.vue?macro=true";
import { default as indexI18CNpu3d8jtN3qIiA_bOQcY8bjZ7GCaFjgxLsckMikMeta } from "/opt/build/repo/website/main/pages/partners/network/index.vue?macro=true";
import { default as indexwulJ_45DjpeopNo1ci2sZA8AsyEVuT1XEKb8NDO_x4l24Meta } from "/opt/build/repo/website/main/pages/unified-commerce/index.vue?macro=true";
import { default as _91slug_93Fo_45__MP8KiGc8h2qv_45b5nfpOC_NEdIugyOefXAGLOwEMeta } from "/opt/build/repo/website/main/pages/giving/nonprofit/[slug].vue?macro=true";
import { default as indexL_45mmV1sz3u0ZyH7AhPpeUdQgohzufeu1BPqAhpcVCjwMeta } from "/opt/build/repo/website/main/pages/industries/retail/index.vue?macro=true";
import { default as indexVVzLQzI39iw355Hse2Tlma80DbBzddtC_459kmihf_45230Meta } from "/opt/build/repo/website/main/pages/platform-payments/index.vue?macro=true";
import { default as indexsuYxo6vVkPEhxjyqT83aXvXxWFNgnrLGGk35q2HBcLEMeta } from "/opt/build/repo/website/main/pages/industries/digital/index.vue?macro=true";
import { default as indexSFb8DGYej4z1sBAT2ww0qa2trOuxvLH9YiyDTaX27xkMeta } from "/opt/build/repo/website/main/pages/platform-directory/index.vue?macro=true";
import { default as indexAm9G_45cTogtEswf5DCYNrHU2jmQu46PD4d2XBgvwlB2IMeta } from "/opt/build/repo/website/main/pages/industries/mobility/index.vue?macro=true";
import { default as indexEE9FzQPe_45AN2_45FfSUcbxARy397Y0se26FnXygV8yikMMeta } from "/opt/build/repo/website/main/pages/industries/platforms/index.vue?macro=true";
import { default as indexOiiyvysmpR2idLq02apltFcnITKAHbl4yJK4DboAY_4Meta } from "/opt/build/repo/website/main/pages/index-reports/previous/index.vue?macro=true";
import { default as indexnPTbNFyMKPkkZPQLmaU3OtUJ5fCYpM32VRdTr_HbkiwMeta } from "/opt/build/repo/website/main/pages/industries/hospitality/index.vue?macro=true";
import { default as indexg4HKz2i9rntvSeMu9m4uOF_7XFTOEFNn6g0ZiYCpQ_oMeta } from "/opt/build/repo/website/main/pages/industries/omnichannel/index.vue?macro=true";
import { default as indexhjMYEcqVdu7Xn1_45wn7_45W_MdxlrWfA6cpnG4MTsXmZG0Meta } from "/opt/build/repo/website/main/pages/online-payments/in-app/index.vue?macro=true";
import { default as indexhPdqi_456trwXai8aPs90ugdPTKFSf3MUq8PP3mu0h_4IMeta } from "/opt/build/repo/website/main/pages/industries/subscription/index.vue?macro=true";
import { default as index7wRiOUC1_hiGT0NrvDOIgw8Z0vmj3efoG2DYU89rtzYMeta } from "/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue?macro=true";
import { default as _91slug_93Ngu3zDM3vx_vyjIiEbjizOIC5P6uu2vCDASx09bN_456MMeta } from "/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue?macro=true";
import { default as indexTA4PkCyPK321YWgLoK3_iDsn_45uqcRNz4POyTCeRz2FoMeta } from "/opt/build/repo/website/main/pages/global-payment-processing/index.vue?macro=true";
import { default as _91slug_93tugNZqXglvTw5QHaIsCfM_qLM1ePr6LXG_o91GrAI9MMeta } from "/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue?macro=true";
import { default as indexXdm4HMaNg5sBFuR8jeaBvemvgC_45JIne_455IvuGKmKF4QMeta } from "/opt/build/repo/website/main/pages/industries/saas-platforms/index.vue?macro=true";
import { default as index9wiFR3PS2rMRbMZAm_455rDIKI_zjf06DJi5U18ytGBPkMeta } from "/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue?macro=true";
import { default as indexFwRnnTm2Mq2mdEMpb053m6ihN48YUY0yW2_45iZVSrjYYMeta } from "/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue?macro=true";
import { default as privacy_45form99Te2YLrFTkTKRAH9bS2Q0Yz6y_YH5szW_45ctzyECMt4Meta } from "/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue?macro=true";
import { default as cookie_45policyhmSK15L_45yhlW0NZyaOiiSJ3HOCozvSZ6eEfls7fRF6AMeta } from "/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue?macro=true";
import { default as indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta } from "/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue?macro=true";
export default [
  {
    name: "error___en",
    path: "/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AU",
    path: "/en_AU/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_BR",
    path: "/pt_BR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___zh_CN",
    path: "/zh_CN/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___cs_CZ",
    path: "/cs_CZ/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___da_DK",
    path: "/da_DK/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___de_DE",
    path: "/de_DE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_ES",
    path: "/es_ES/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___fr_FR",
    path: "/fr_FR/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___it_IT",
    path: "/it_IT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___ja_JP",
    path: "/ja_JP/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___es_MX",
    path: "/es_MX/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___nl_NL",
    path: "/nl_NL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___no_NO",
    path: "/no_NO/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pl_PL",
    path: "/pl_PL/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___pt_PT",
    path: "/pt_PT/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___sv_SE",
    path: "/sv_SE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_AE",
    path: "/en_AE/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_SG",
    path: "/en_SG/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "error___en_GB",
    path: "/en_GB/error",
    component: () => import("/opt/build/repo/website/core/pages/error.vue")
  },
  {
    name: "index___en",
    path: "/",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___en_AU",
    path: "/en_AU",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___pt_BR",
    path: "/pt_BR",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___zh_CN",
    path: "/zh_CN",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___cs_CZ",
    path: "/cs_CZ",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___da_DK",
    path: "/da_DK",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___de_DE",
    path: "/de_DE",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___es_ES",
    path: "/es_ES",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___fr_FR",
    path: "/fr_FR",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___it_IT",
    path: "/it_IT",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___ja_JP",
    path: "/ja_JP",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___es_MX",
    path: "/es_MX",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___nl_NL",
    path: "/nl_NL",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___no_NO",
    path: "/no_NO",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___pl_PL",
    path: "/pl_PL",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___pt_PT",
    path: "/pt_PT",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___sv_SE",
    path: "/sv_SE",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___en_AE",
    path: "/en_AE",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___en_SG",
    path: "/en_SG",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "index___en_GB",
    path: "/en_GB",
    meta: indexRDlVRsJNtKvTUvNj8RiW5IgU6ejKggui8E_452i6OIoQwMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/index.vue")
  },
  {
    name: "about___en",
    path: "/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___en_AU",
    path: "/en_AU/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___pt_BR",
    path: "/pt_BR/sobre",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___zh_CN",
    path: "/zh_CN/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___da_DK",
    path: "/da_DK/om-os",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___de_DE",
    path: "/de_DE/uber",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___es_ES",
    path: "/es_ES/acerca-de",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___fr_FR",
    path: "/fr_FR/a-propos-de",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___it_IT",
    path: "/it_IT/su-di-noi",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___ja_JP",
    path: "/ja_JP/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___es_MX",
    path: "/es_MX/acerca-de",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___nl_NL",
    path: "/nl_NL/over-adyen",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___no_NO",
    path: "/no_NO/om",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___pl_PL",
    path: "/pl_PL/informacje",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___pt_PT",
    path: "/pt_PT/sobre",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___sv_SE",
    path: "/sv_SE/om",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___en_AE",
    path: "/en_AE/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___en_SG",
    path: "/en_SG/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "about___en_GB",
    path: "/en_GB/about",
    meta: indexAxitCyYeCs1fnoNO75NZo_45MYtU9yT4fr38hgZMIoduQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/about/index.vue")
  },
  {
    name: "legal___en",
    path: "/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___en_AU",
    path: "/en_AU/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___pt_BR",
    path: "/pt_BR/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___zh_CN",
    path: "/zh_CN/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___cs_CZ",
    path: "/cs_CZ/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___da_DK",
    path: "/da_DK/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___de_DE",
    path: "/de_DE/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___es_ES",
    path: "/es_ES/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___fr_FR",
    path: "/fr_FR/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___it_IT",
    path: "/it_IT/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___ja_JP",
    path: "/ja_JP/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___es_MX",
    path: "/es_MX/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___nl_NL",
    path: "/nl_NL/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___no_NO",
    path: "/no_NO/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___pl_PL",
    path: "/pl_PL/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___pt_PT",
    path: "/pt_PT/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___sv_SE",
    path: "/sv_SE/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___en_AE",
    path: "/en_AE/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___en_SG",
    path: "/en_SG/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "legal___en_GB",
    path: "/en_GB/legal",
    component: () => import("/opt/build/repo/website/main/pages/legal/index.vue")
  },
  {
    name: "about-slug___en",
    path: "/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___en_AU",
    path: "/en_AU/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___pt_BR",
    path: "/pt_BR/sobre/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___zh_CN",
    path: "/zh_CN/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___da_DK",
    path: "/da_DK/om-os/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___de_DE",
    path: "/de_DE/uber/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___es_ES",
    path: "/es_ES/acerca-de/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___fr_FR",
    path: "/fr_FR/a-propos-de/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___it_IT",
    path: "/it_IT/su-di-noi/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___ja_JP",
    path: "/ja_JP/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___es_MX",
    path: "/es_MX/acerca-de/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___nl_NL",
    path: "/nl_NL/over-adyen/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___no_NO",
    path: "/no_NO/om/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___pl_PL",
    path: "/pl_PL/informacje/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___pt_PT",
    path: "/pt_PT/sobre/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___sv_SE",
    path: "/sv_SE/om/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___en_AE",
    path: "/en_AE/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___en_SG",
    path: "/en_SG/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "about-slug___en_GB",
    path: "/en_GB/about/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/about/[slug].vue")
  },
  {
    name: "giving___en",
    path: "/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___en_AU",
    path: "/en_AU/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___da_DK",
    path: "/da_DK/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___de_DE",
    path: "/de_DE/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___es_ES",
    path: "/es_ES/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___fr_FR",
    path: "/fr_FR/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___it_IT",
    path: "/it_IT/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___ja_JP",
    path: "/ja_JP/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___nl_NL",
    path: "/nl_NL/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___no_NO",
    path: "/no_NO/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___pl_PL",
    path: "/pl_PL/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___pt_PT",
    path: "/pt_PT/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___sv_SE",
    path: "/sv_SE/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___en_AE",
    path: "/en_AE/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___en_SG",
    path: "/en_SG/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "giving___en_GB",
    path: "/en_GB/giving",
    meta: indexKIWkwCyslYAObE_IMTdzxi_45o1uC3BHI5N430lzUulcIMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/index.vue")
  },
  {
    name: "legal-slug___en",
    path: "/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___en_AU",
    path: "/en_AU/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___pt_BR",
    path: "/pt_BR/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___zh_CN",
    path: "/zh_CN/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___cs_CZ",
    path: "/cs_CZ/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___da_DK",
    path: "/da_DK/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___de_DE",
    path: "/de_DE/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___es_ES",
    path: "/es_ES/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___fr_FR",
    path: "/fr_FR/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___it_IT",
    path: "/it_IT/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___ja_JP",
    path: "/ja_JP/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___es_MX",
    path: "/es_MX/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___nl_NL",
    path: "/nl_NL/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___no_NO",
    path: "/no_NO/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___pl_PL",
    path: "/pl_PL/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___pt_PT",
    path: "/pt_PT/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___sv_SE",
    path: "/sv_SE/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___en_AE",
    path: "/en_AE/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___en_SG",
    path: "/en_SG/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "legal-slug___en_GB",
    path: "/en_GB/legal/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/legal/[slug].vue")
  },
  {
    name: "uplift___en",
    path: "/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___en_AU",
    path: "/en_AU/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___pt_BR",
    path: "/pt_BR/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___zh_CN",
    path: "/zh_CN/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___cs_CZ",
    path: "/cs_CZ/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___da_DK",
    path: "/da_DK/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___de_DE",
    path: "/de_DE/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___es_ES",
    path: "/es_ES/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___fr_FR",
    path: "/fr_FR/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___it_IT",
    path: "/it_IT/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___ja_JP",
    path: "/ja_JP/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___es_MX",
    path: "/es_MX/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___nl_NL",
    path: "/nl_NL/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___no_NO",
    path: "/no_NO/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___pl_PL",
    path: "/pl_PL/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___pt_PT",
    path: "/pt_PT/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___sv_SE",
    path: "/sv_SE/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___en_AE",
    path: "/en_AE/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___en_SG",
    path: "/en_SG/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "uplift___en_GB",
    path: "/en_GB/uplift",
    meta: indexFeYBw9NWOT0OfQUf_45A_Zz8D6IxcGj9YHKVqpmHv60W0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/index.vue")
  },
  {
    name: "capital___en",
    path: "/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___en_AU",
    path: "/en_AU/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___da_DK",
    path: "/da_DK/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___de_DE",
    path: "/de_DE/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___es_ES",
    path: "/es_ES/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___fr_FR",
    path: "/fr_FR/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___it_IT",
    path: "/it_IT/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___nl_NL",
    path: "/nl_NL/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___no_NO",
    path: "/no_NO/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___pl_PL",
    path: "/pl_PL/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___pt_PT",
    path: "/pt_PT/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___sv_SE",
    path: "/sv_SE/kapital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___en_SG",
    path: "/en_SG/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "capital___en_GB",
    path: "/en_GB/capital",
    meta: indexKpfg1m9i3wdsVpu5uZpDaACTcyaAy5_TfrLcBUmvpqMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/capital/index.vue")
  },
  {
    name: "contact___en",
    path: "/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___en_AU",
    path: "/en_AU/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___pt_BR",
    path: "/pt_BR/contato",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___zh_CN",
    path: "/zh_CN/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___cs_CZ",
    path: "/cs_CZ/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___da_DK",
    path: "/da_DK/kontakt",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___de_DE",
    path: "/de_DE/kontakt",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___es_ES",
    path: "/es_ES/contacto",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___fr_FR",
    path: "/fr_FR/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___it_IT",
    path: "/it_IT/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___ja_JP",
    path: "/ja_JP/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___es_MX",
    path: "/es_MX/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___nl_NL",
    path: "/nl_NL/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___no_NO",
    path: "/no_NO/kontakt",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___pl_PL",
    path: "/pl_PL/kontakt",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___pt_PT",
    path: "/pt_PT/contato",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___sv_SE",
    path: "/sv_SE/kontakt",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___en_AE",
    path: "/en_AE/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___en_SG",
    path: "/en_SG/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "contact___en_GB",
    path: "/en_GB/contact",
    component: () => import("/opt/build/repo/website/main/pages/contact/index.vue")
  },
  {
    name: "issuing___en",
    path: "/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___en_AU",
    path: "/en_AU/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___zh_CN",
    path: "/zh_CN/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___cs_CZ",
    path: "/cs_CZ/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___da_DK",
    path: "/da_DK/udstedelse",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___de_DE",
    path: "/de_DE/card-issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___es_ES",
    path: "/es_ES/emision-de-tarjetas",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___fr_FR",
    path: "/fr_FR/emission-carte",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___it_IT",
    path: "/it_IT/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___nl_NL",
    path: "/nl_NL/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___no_NO",
    path: "/no_NO/utstedelse",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___pl_PL",
    path: "/pl_PL/wydawanie-kart",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___pt_PT",
    path: "/pt_PT/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___sv_SE",
    path: "/sv_SE/kortutgivning",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___en_SG",
    path: "/en_SG/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "issuing___en_GB",
    path: "/en_GB/issuing",
    meta: indexNxL1YQfLp7K4fF_LFeqJGVwrGnGUIJhevGZH7Kiuf3sMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/issuing/index.vue")
  },
  {
    name: "offices___en",
    path: "/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___en_AU",
    path: "/en_AU/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___pt_BR",
    path: "/pt_BR/escritorios",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___zh_CN",
    path: "/zh_CN/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___da_DK",
    path: "/da_DK/kontorer",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___de_DE",
    path: "/de_DE/standorte",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___es_ES",
    path: "/es_ES/oficinas",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___fr_FR",
    path: "/fr_FR/bureaux",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___it_IT",
    path: "/it_IT/uffici",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___ja_JP",
    path: "/ja_JP/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___es_MX",
    path: "/es_MX/oficinas",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___nl_NL",
    path: "/nl_NL/kantoren",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___no_NO",
    path: "/no_NO/kontorer",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___pl_PL",
    path: "/pl_PL/biura",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___pt_PT",
    path: "/pt_PT/escritorios",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___sv_SE",
    path: "/sv_SE/kontor",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___en_AE",
    path: "/en_AE/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___en_SG",
    path: "/en_SG/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "offices___en_GB",
    path: "/en_GB/offices",
    component: () => import("/opt/build/repo/website/main/pages/offices/index.vue")
  },
  {
    name: "payouts___en",
    path: "/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___en_AU",
    path: "/en_AU/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___da_DK",
    path: "/da_DK/udbetalinger",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___de_DE",
    path: "/de_DE/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___es_ES",
    path: "/es_ES/de-pagos",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___fr_FR",
    path: "/fr_FR/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___it_IT",
    path: "/it_IT/pagamenti",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___nl_NL",
    path: "/nl_NL/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___no_NO",
    path: "/no_NO/utbetalinger",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___pl_PL",
    path: "/pl_PL/wyplaty",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___pt_PT",
    path: "/pt_PT/liquidacoes",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___sv_SE",
    path: "/sv_SE/utbetalningar",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___en_SG",
    path: "/en_SG/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "payouts___en_GB",
    path: "/en_GB/payouts",
    component: () => import("/opt/build/repo/website/main/pages/payouts/index.vue")
  },
  {
    name: "plugins___en",
    path: "/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___en_AU",
    path: "/en_AU/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___pt_BR",
    path: "/pt_BR/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___zh_CN",
    path: "/zh_CN/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___da_DK",
    path: "/da_DK/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___de_DE",
    path: "/de_DE/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___es_ES",
    path: "/es_ES/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___fr_FR",
    path: "/fr_FR/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___it_IT",
    path: "/it_IT/plug-in",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___es_MX",
    path: "/es_MX/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___nl_NL",
    path: "/nl_NL/plug-ins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___no_NO",
    path: "/no_NO/programtillegg",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___pl_PL",
    path: "/pl_PL/platnosci-wtyczki-e-commerce",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___pt_PT",
    path: "/pt_PT/plug-ins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___sv_SE",
    path: "/sv_SE/plugin",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___en_AE",
    path: "/en_AE/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___en_SG",
    path: "/en_SG/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "plugins___en_GB",
    path: "/en_GB/plugins",
    meta: indexFROYWmhnvnAmZW5rDi5l3tFDoLEIlub7OnWH1uvd9csMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/plugins/index.vue")
  },
  {
    name: "uplift-slug___en",
    path: "/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___en_AU",
    path: "/en_AU/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___pt_BR",
    path: "/pt_BR/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___zh_CN",
    path: "/zh_CN/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___cs_CZ",
    path: "/cs_CZ/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___da_DK",
    path: "/da_DK/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___de_DE",
    path: "/de_DE/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___es_ES",
    path: "/es_ES/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___fr_FR",
    path: "/fr_FR/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___it_IT",
    path: "/it_IT/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___ja_JP",
    path: "/ja_JP/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___es_MX",
    path: "/es_MX/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___nl_NL",
    path: "/nl_NL/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___no_NO",
    path: "/no_NO/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___pl_PL",
    path: "/pl_PL/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___pt_PT",
    path: "/pt_PT/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___sv_SE",
    path: "/sv_SE/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___en_AE",
    path: "/en_AE/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___en_SG",
    path: "/en_SG/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "uplift-slug___en_GB",
    path: "/en_GB/uplift/:slug()",
    meta: _91slug_93ywSgU7sJda0i6nzfCuMFLA0n6U4vAxwD6RwPsvgqYi0Meta || {},
    component: () => import("/opt/build/repo/website/main/pages/uplift/[slug].vue")
  },
  {
    name: "accounts___en",
    path: "/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___en_AU",
    path: "/en_AU/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___da_DK",
    path: "/da_DK/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___de_DE",
    path: "/de_DE/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___es_ES",
    path: "/es_ES/cuentas",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___fr_FR",
    path: "/fr_FR/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___it_IT",
    path: "/it_IT/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___nl_NL",
    path: "/nl_NL/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___no_NO",
    path: "/no_NO/kontoer",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___pl_PL",
    path: "/pl_PL/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___pt_PT",
    path: "/pt_PT/contas",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___sv_SE",
    path: "/sv_SE/konton",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___en_SG",
    path: "/en_SG/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "accounts___en_GB",
    path: "/en_GB/accounts",
    component: () => import("/opt/build/repo/website/main/pages/accounts/index.vue")
  },
  {
    name: "contact-slug___en",
    path: "/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___en_AU",
    path: "/en_AU/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___pt_BR",
    path: "/pt_BR/contato/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___zh_CN",
    path: "/zh_CN/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___cs_CZ",
    path: "/cs_CZ/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___da_DK",
    path: "/da_DK/kontakt/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___de_DE",
    path: "/de_DE/kontakt/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___es_ES",
    path: "/es_ES/contacto/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___fr_FR",
    path: "/fr_FR/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___it_IT",
    path: "/it_IT/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___ja_JP",
    path: "/ja_JP/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___es_MX",
    path: "/es_MX/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___nl_NL",
    path: "/nl_NL/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___no_NO",
    path: "/no_NO/kontakt/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___pl_PL",
    path: "/pl_PL/kontakt/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___pt_PT",
    path: "/pt_PT/contato/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___sv_SE",
    path: "/sv_SE/kontakt/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___en_AE",
    path: "/en_AE/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___en_SG",
    path: "/en_SG/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "contact-slug___en_GB",
    path: "/en_GB/contact/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/contact/[slug].vue")
  },
  {
    name: "licenses___en",
    path: "/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___en_AU",
    path: "/en_AU/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___pt_BR",
    path: "/pt_BR/licencas",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___zh_CN",
    path: "/zh_CN/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___cs_CZ",
    path: "/cs_CZ/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___da_DK",
    path: "/da_DK/licenser",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___de_DE",
    path: "/de_DE/lizenzen",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___es_ES",
    path: "/es_ES/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___fr_FR",
    path: "/fr_FR/licences",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___it_IT",
    path: "/it_IT/licenze",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___ja_JP",
    path: "/ja_JP/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___es_MX",
    path: "/es_MX/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___nl_NL",
    path: "/nl_NL/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___no_NO",
    path: "/no_NO/lisenser",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___pl_PL",
    path: "/pl_PL/licencje",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___pt_PT",
    path: "/pt_PT/licencas",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___sv_SE",
    path: "/sv_SE/licenser",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___en_AE",
    path: "/en_AE/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "licenses___en_GB",
    path: "/en_GB/licenses",
    component: () => import("/opt/build/repo/website/main/pages/licenses/index.vue")
  },
  {
    name: "partners___en",
    path: "/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___en_AU",
    path: "/en_AU/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___pt_BR",
    path: "/pt_BR/parceiros",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___zh_CN",
    path: "/zh_CN/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___da_DK",
    path: "/da_DK/partnere",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___de_DE",
    path: "/de_DE/partner",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___es_ES",
    path: "/es_ES/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___fr_FR",
    path: "/fr_FR/partenaires",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___it_IT",
    path: "/it_IT/partner",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___nl_NL",
    path: "/nl_NL/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___no_NO",
    path: "/no_NO/partnere",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___pl_PL",
    path: "/pl_PL/partnerzy",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___sv_SE",
    path: "/sv_SE/partner",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___en_AE",
    path: "/en_AE/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___en_SG",
    path: "/en_SG/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "partners___en_GB",
    path: "/en_GB/partners",
    component: () => import("/opt/build/repo/website/main/pages/partners/index.vue")
  },
  {
    name: "customers___en",
    path: "/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___en_AU",
    path: "/en_AU/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___pt_BR",
    path: "/pt_BR/clientes",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___zh_CN",
    path: "/zh_CN/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___cs_CZ",
    path: "/cs_CZ/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___da_DK",
    path: "/da_DK/kunder",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___de_DE",
    path: "/de_DE/kunden",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___es_ES",
    path: "/es_ES/clientes",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___fr_FR",
    path: "/fr_FR/clients",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___it_IT",
    path: "/it_IT/clienti",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___ja_JP",
    path: "/ja_JP/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___es_MX",
    path: "/es_MX/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___nl_NL",
    path: "/nl_NL/klanten",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___no_NO",
    path: "/no_NO/kunder",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___pl_PL",
    path: "/pl_PL/klienci",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___pt_PT",
    path: "/pt_PT/clientes",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___sv_SE",
    path: "/sv_SE/referenser",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___en_AE",
    path: "/en_AE/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___en_SG",
    path: "/en_SG/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "customers___en_GB",
    path: "/en_GB/customers",
    meta: indexWyAx8P78OaUDzvLDCt9bx07kpTXv5GQDJFZHlxEBSEEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/customers/index.vue")
  },
  {
    name: "licenses-slug___en",
    path: "/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___en_AU",
    path: "/en_AU/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___pt_BR",
    path: "/pt_BR/licencas/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___zh_CN",
    path: "/zh_CN/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___cs_CZ",
    path: "/cs_CZ/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___da_DK",
    path: "/da_DK/licenser/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___de_DE",
    path: "/de_DE/lizenzen/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___es_ES",
    path: "/es_ES/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___fr_FR",
    path: "/fr_FR/licences/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___it_IT",
    path: "/it_IT/licenze/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___ja_JP",
    path: "/ja_JP/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___es_MX",
    path: "/es_MX/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___nl_NL",
    path: "/nl_NL/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___no_NO",
    path: "/no_NO/lisenser/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___pl_PL",
    path: "/pl_PL/licencje/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___pt_PT",
    path: "/pt_PT/licencas/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___sv_SE",
    path: "/sv_SE/licenser/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___en_AE",
    path: "/en_AE/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "licenses-slug___en_GB",
    path: "/en_GB/licenses/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/licenses/[slug].vue")
  },
  {
    name: "partners-slug___en",
    path: "/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___en_AU",
    path: "/en_AU/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___pt_BR",
    path: "/pt_BR/parceiros/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___zh_CN",
    path: "/zh_CN/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___da_DK",
    path: "/da_DK/partnere/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___de_DE",
    path: "/de_DE/partner/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___es_ES",
    path: "/es_ES/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___fr_FR",
    path: "/fr_FR/partenaires/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___it_IT",
    path: "/it_IT/partner/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___nl_NL",
    path: "/nl_NL/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___no_NO",
    path: "/no_NO/partnere/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___pl_PL",
    path: "/pl_PL/partnerzy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___sv_SE",
    path: "/sv_SE/partner/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___en_AE",
    path: "/en_AE/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___en_SG",
    path: "/en_SG/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "partners-slug___en_GB",
    path: "/en_GB/partners/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/partners/[slug].vue")
  },
  {
    name: "industries___en",
    path: "/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___en_AU",
    path: "/en_AU/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___pt_BR",
    path: "/pt_BR/setores",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___zh_CN",
    path: "/zh_CN/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___cs_CZ",
    path: "/cs_CZ/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___da_DK",
    path: "/da_DK/industrier",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___de_DE",
    path: "/de_DE/branchen",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___es_ES",
    path: "/es_ES/sectores",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___fr_FR",
    path: "/fr_FR/secteurs",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___it_IT",
    path: "/it_IT/settori",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___ja_JP",
    path: "/ja_JP/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___es_MX",
    path: "/es_MX/industrias",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___nl_NL",
    path: "/nl_NL/industrieen",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___no_NO",
    path: "/no_NO/bransjer",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___pl_PL",
    path: "/pl_PL/branze",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___pt_PT",
    path: "/pt_PT/setores",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___sv_SE",
    path: "/sv_SE/branscher",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___en_AE",
    path: "/en_AE/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___en_SG",
    path: "/en_SG/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "industries___en_GB",
    path: "/en_GB/industries",
    component: () => import("/opt/build/repo/website/main/pages/industries/index.vue")
  },
  {
    name: "the-latest___en",
    path: "/the-latest",
    component: () => import("/opt/build/repo/website/main/pages/the-latest/index.vue")
  },
  {
    name: "pay-by-link___en",
    path: "/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___en_AU",
    path: "/en_AU/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___pt_BR",
    path: "/pt_BR/link-de-pagamento",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___zh_CN",
    path: "/zh_CN/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___cs_CZ",
    path: "/cs_CZ/platebni-odkaz",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___da_DK",
    path: "/da_DK/betalingslink",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___de_DE",
    path: "/de_DE/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___es_ES",
    path: "/es_ES/pagos-por-enlace",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___fr_FR",
    path: "/fr_FR/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___it_IT",
    path: "/it_IT/paga-tramite-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___ja_JP",
    path: "/ja_JP/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___es_MX",
    path: "/es_MX/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___nl_NL",
    path: "/nl_NL/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___no_NO",
    path: "/no_NO/betalingslenke",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___pl_PL",
    path: "/pl_PL/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___pt_PT",
    path: "/pt_PT/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___sv_SE",
    path: "/sv_SE/betallank",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___en_AE",
    path: "/en_AE/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___en_SG",
    path: "/en_SG/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "pay-by-link___en_GB",
    path: "/en_GB/pay-by-link",
    meta: indexFT_45ckXANe6DP7xNn9GuXdtPMnISMp0ocI06MuaHf0DQMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pay-by-link/index.vue")
  },
  {
    name: "the-latest-slug___en",
    path: "/the-latest/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/the-latest/[slug].vue")
  },
  {
    name: "pos-payments___en",
    path: "/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___en_AU",
    path: "/en_AU/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___pt_BR",
    path: "/pt_BR/terminais-pagamento",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___zh_CN",
    path: "/zh_CN/pos",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___cs_CZ",
    path: "/cs_CZ/platby-pos-platebnl-terminaly",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___da_DK",
    path: "/da_DK/pos-betalinger",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___de_DE",
    path: "/de_DE/pos-zahlungen",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___es_ES",
    path: "/es_ES/pagos-tpv",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___fr_FR",
    path: "/fr_FR/paiements-en-point-de-vente",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___it_IT",
    path: "/it_IT/pagamenti-pos",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___ja_JP",
    path: "/ja_JP/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___es_MX",
    path: "/es_MX/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___nl_NL",
    path: "/nl_NL/pos-betalingen",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___no_NO",
    path: "/no_NO/pos-betalinger",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___pl_PL",
    path: "/pl_PL/platnosci-pos",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___pt_PT",
    path: "/pt_PT/terminais-pagamento",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___sv_SE",
    path: "/sv_SE/fysiska-betalningar",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___en_AE",
    path: "/en_AE/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___en_SG",
    path: "/en_SG/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "pos-payments___en_GB",
    path: "/en_GB/pos-payments",
    meta: indexJ_450hstSdxmzgTqrhJerdSnzshuU1StHxkWyngD0CYfAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/index.vue")
  },
  {
    name: "web-payments___en",
    path: "/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___en_AU",
    path: "/en_AU/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___pt_BR",
    path: "/pt_BR/pagamentos-navegador",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___zh_CN",
    path: "/zh_CN/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___cs_CZ",
    path: "/cs_CZ/webove-platby",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___da_DK",
    path: "/da_DK/netbetalinger",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___de_DE",
    path: "/de_DE/ecommerce-zahlungen",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___es_ES",
    path: "/es_ES/pagos-web",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___fr_FR",
    path: "/fr_FR/paiements-web",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___it_IT",
    path: "/it_IT/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___es_MX",
    path: "/es_MX/pagos-web",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___nl_NL",
    path: "/nl_NL/web-betalingen",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___no_NO",
    path: "/no_NO/web-nettbetalinger",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___pl_PL",
    path: "/pl_PL/platnosci-internetowe-checkout",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___pt_PT",
    path: "/pt_PT/pagamentos-navegador",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___sv_SE",
    path: "/sv_SE/webbetalningar",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___en_AE",
    path: "/en_AE/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___en_SG",
    path: "/en_SG/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "web-payments___en_GB",
    path: "/en_GB/web-payments",
    meta: indexfhgqNv1UkHVby93fy4MV8wacIM8T5tfBKMbXntTef6cMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/web-payments/index.vue")
  },
  {
    name: "customer-area___en",
    path: "/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___en_AU",
    path: "/en_AU/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___pt_BR",
    path: "/pt_BR/relatorios",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___zh_CN",
    path: "/zh_CN/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___da_DK",
    path: "/da_DK/rapportering",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___de_DE",
    path: "/de_DE/berichterstattung",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___es_ES",
    path: "/es_ES/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___fr_FR",
    path: "/fr_FR/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___it_IT",
    path: "/it_IT/report",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___ja_JP",
    path: "/ja_JP/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___es_MX",
    path: "/es_MX/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___nl_NL",
    path: "/nl_NL/rapportage",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___no_NO",
    path: "/no_NO/rapportering",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___pl_PL",
    path: "/pl_PL/raporty",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___pt_PT",
    path: "/pt_PT/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___sv_SE",
    path: "/sv_SE/rapportering",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___en_AE",
    path: "/en_AE/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___en_SG",
    path: "/en_SG/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "customer-area___en_GB",
    path: "/en_GB/customer-area",
    component: () => import("/opt/build/repo/website/main/pages/customer-area/index.vue")
  },
  {
    name: "index-reports___en",
    path: "/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___en_AU",
    path: "/en_AU/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___pt_BR",
    path: "/pt_BR/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___zh_CN",
    path: "/zh_CN/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___cs_CZ",
    path: "/cs_CZ/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___da_DK",
    path: "/da_DK/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___de_DE",
    path: "/de_DE/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___es_ES",
    path: "/es_ES/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___fr_FR",
    path: "/fr_FR/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___it_IT",
    path: "/it_IT/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___ja_JP",
    path: "/ja_JP/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___es_MX",
    path: "/es_MX/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___nl_NL",
    path: "/nl_NL/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___no_NO",
    path: "/no_NO/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___pl_PL",
    path: "/pl_PL/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___pt_PT",
    path: "/pt_PT/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___sv_SE",
    path: "/sv_SE/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___en_AE",
    path: "/en_AE/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___en_SG",
    path: "/en_SG/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports___en_GB",
    path: "/en_GB/index-reports",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/index.vue")
  },
  {
    name: "index-reports-slug___en",
    path: "/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___en_AU",
    path: "/en_AU/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___pt_BR",
    path: "/pt_BR/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___zh_CN",
    path: "/zh_CN/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___cs_CZ",
    path: "/cs_CZ/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___da_DK",
    path: "/da_DK/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___de_DE",
    path: "/de_DE/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___es_ES",
    path: "/es_ES/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___fr_FR",
    path: "/fr_FR/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___it_IT",
    path: "/it_IT/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___ja_JP",
    path: "/ja_JP/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___es_MX",
    path: "/es_MX/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___nl_NL",
    path: "/nl_NL/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___no_NO",
    path: "/no_NO/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___pl_PL",
    path: "/pl_PL/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___pt_PT",
    path: "/pt_PT/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___sv_SE",
    path: "/sv_SE/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___en_AE",
    path: "/en_AE/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___en_SG",
    path: "/en_SG/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "index-reports-slug___en_GB",
    path: "/en_GB/index-reports/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[slug].vue")
  },
  {
    name: "infrastructure___en",
    path: "/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___en_AU",
    path: "/en_AU/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___pt_BR",
    path: "/pt_BR/infraestrutura",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___zh_CN",
    path: "/zh_CN/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___da_DK",
    path: "/da_DK/infrastruktur",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___de_DE",
    path: "/de_DE/infrastruktur",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___es_ES",
    path: "/es_ES/infraestructura",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___fr_FR",
    path: "/fr_FR/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___it_IT",
    path: "/it_IT/infrastruttura",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___es_MX",
    path: "/es_MX/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___nl_NL",
    path: "/nl_NL/infrastructuur",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___no_NO",
    path: "/no_NO/infrastruktur",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___pl_PL",
    path: "/pl_PL/infrastruktura",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___pt_PT",
    path: "/pt_PT/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___sv_SE",
    path: "/sv_SE/infrastruktur",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___en_AE",
    path: "/en_AE/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "infrastructure___en_GB",
    path: "/en_GB/infrastructure",
    component: () => import("/opt/build/repo/website/main/pages/infrastructure/index.vue")
  },
  {
    name: "privacy-policy___en",
    path: "/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___en_AU",
    path: "/en_AU/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___pt_BR",
    path: "/pt_BR/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___zh_CN",
    path: "/zh_CN/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___cs_CZ",
    path: "/cs_CZ/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___da_DK",
    path: "/da_DK/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___de_DE",
    path: "/de_DE/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___es_ES",
    path: "/es_ES/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___fr_FR",
    path: "/fr_FR/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___it_IT",
    path: "/it_IT/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___ja_JP",
    path: "/ja_JP/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___es_MX",
    path: "/es_MX/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___nl_NL",
    path: "/nl_NL/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___no_NO",
    path: "/no_NO/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___pl_PL",
    path: "/pl_PL/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___pt_PT",
    path: "/pt_PT/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___sv_SE",
    path: "/sv_SE/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___en_AE",
    path: "/en_AE/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___en_SG",
    path: "/en_SG/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy___en_GB",
    path: "/en_GB/privacy-policy",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/index.vue")
  },
  {
    name: "accept-payments___en",
    path: "/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___en_AU",
    path: "/en_AU/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___pt_BR",
    path: "/pt_BR/aceite-pagamentos",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___zh_CN",
    path: "/zh_CN/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___da_DK",
    path: "/da_DK/accepter-betalinger",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___de_DE",
    path: "/de_DE/zahlungen-empfangen",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___es_ES",
    path: "/es_ES/plataforma-de-pagos",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___fr_FR",
    path: "/fr_FR/accepter-les-paiements",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___it_IT",
    path: "/it_IT/accettazione-pagamenti",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___es_MX",
    path: "/es_MX/acepta-pagos",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___nl_NL",
    path: "/nl_NL/accepteer-betalingen",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___no_NO",
    path: "/no_NO/aksepter-betalinger",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___sv_SE",
    path: "/sv_SE/ta-emot-betalningar",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___en_AE",
    path: "/en_AE/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___en_SG",
    path: "/en_SG/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "accept-payments___en_GB",
    path: "/en_GB/accept-payments",
    meta: indexnhjuXCeMidJ4mrhYDBETiDEocuY3jLWMceQM9LVEJGMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/accept-payments/index.vue")
  },
  {
    name: "online-payments___en",
    path: "/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___en_AU",
    path: "/en_AU/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___pt_BR",
    path: "/pt_BR/pagamentos-online",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___zh_CN",
    path: "/zh_CN/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___cs_CZ",
    path: "/cs_CZ/online-platebni-brana",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___da_DK",
    path: "/da_DK/online-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___de_DE",
    path: "/de_DE/online-zahlungen",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___es_ES",
    path: "/es_ES/tpv-virtual",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___fr_FR",
    path: "/fr_FR/paiements-en-ligne",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___it_IT",
    path: "/it_IT/pagamenti-online",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___ja_JP",
    path: "/ja_JP/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___es_MX",
    path: "/es_MX/pagos-online",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___nl_NL",
    path: "/nl_NL/online-betalingen",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___no_NO",
    path: "/no_NO/checkout",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___pl_PL",
    path: "/pl_PL/platnosci-online",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___pt_PT",
    path: "/pt_PT/pagamentos-online",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___sv_SE",
    path: "/sv_SE/checkout",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___en_AE",
    path: "/en_AE/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___en_SG",
    path: "/en_SG/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "online-payments___en_GB",
    path: "/en_GB/online-payments",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/index.vue")
  },
  {
    name: "privacy-policy-slug___en",
    path: "/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___en_AU",
    path: "/en_AU/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___pt_BR",
    path: "/pt_BR/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___zh_CN",
    path: "/zh_CN/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___cs_CZ",
    path: "/cs_CZ/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___da_DK",
    path: "/da_DK/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___de_DE",
    path: "/de_DE/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___es_ES",
    path: "/es_ES/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___fr_FR",
    path: "/fr_FR/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___it_IT",
    path: "/it_IT/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___ja_JP",
    path: "/ja_JP/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___es_MX",
    path: "/es_MX/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___nl_NL",
    path: "/nl_NL/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___no_NO",
    path: "/no_NO/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___pl_PL",
    path: "/pl_PL/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___pt_PT",
    path: "/pt_PT/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___sv_SE",
    path: "/sv_SE/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___en_AE",
    path: "/en_AE/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___en_SG",
    path: "/en_SG/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "privacy-policy-slug___en_GB",
    path: "/en_GB/privacy-policy/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/privacy-policy/[slug].vue")
  },
  {
    name: "giving-nonprofit___en",
    path: "/giving/nonprofit",
    meta: indexBxXKwp0_45hGyz50jAGh4_uR4MHgxv7MAwd1ilfW8DpYMMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/nonprofit/index.vue")
  },
  {
    name: "partners-network___en",
    path: "/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___en_AU",
    path: "/en_AU/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___pt_BR",
    path: "/pt_BR/parceiros/rede",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___da_DK",
    path: "/da_DK/partnere/netvaerk",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___de_DE",
    path: "/de_DE/partner/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___es_ES",
    path: "/es_ES/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___fr_FR",
    path: "/fr_FR/partenaires/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___it_IT",
    path: "/it_IT/partner/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___nl_NL",
    path: "/nl_NL/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___no_NO",
    path: "/no_NO/partnere/nettverk",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___pl_PL",
    path: "/pl_PL/partnerzy/siec",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___sv_SE",
    path: "/sv_SE/partner/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___en_AE",
    path: "/en_AE/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___en_SG",
    path: "/en_SG/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "partners-network___en_GB",
    path: "/en_GB/partners/network",
    component: () => import("/opt/build/repo/website/main/pages/partners/network/index.vue")
  },
  {
    name: "unified-commerce___en",
    path: "/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___en_AU",
    path: "/en_AU/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___pt_BR",
    path: "/pt_BR/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___zh_CN",
    path: "/zh_CN/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___cs_CZ",
    path: "/cs_CZ/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___da_DK",
    path: "/da_DK/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___de_DE",
    path: "/de_DE/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___es_ES",
    path: "/es_ES/comercio-unificado",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___fr_FR",
    path: "/fr_FR/commerce-unifie",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___it_IT",
    path: "/it_IT/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___ja_JP",
    path: "/ja_JP/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___es_MX",
    path: "/es_MX/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___nl_NL",
    path: "/nl_NL/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___no_NO",
    path: "/no_NO/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___pl_PL",
    path: "/pl_PL/platnosci-omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___pt_PT",
    path: "/pt_PT/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___sv_SE",
    path: "/sv_SE/omnikanal",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___en_AE",
    path: "/en_AE/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___en_SG",
    path: "/en_SG/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "unified-commerce___en_GB",
    path: "/en_GB/unified-commerce",
    component: () => import("/opt/build/repo/website/main/pages/unified-commerce/index.vue")
  },
  {
    name: "giving-nonprofit-slug___en",
    path: "/giving/nonprofit/:slug()",
    meta: _91slug_93Fo_45__MP8KiGc8h2qv_45b5nfpOC_NEdIugyOefXAGLOwEMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/giving/nonprofit/[slug].vue")
  },
  {
    name: "industries-retail___en",
    path: "/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___en_AU",
    path: "/en_AU/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___pt_BR",
    path: "/pt_BR/setores/pagamentos-para-varejo",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___zh_CN",
    path: "/zh_CN/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___cs_CZ",
    path: "/cs_CZ/industries/maloobchod",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___da_DK",
    path: "/da_DK/industrier/detailhandel-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___de_DE",
    path: "/de_DE/branchen/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___es_ES",
    path: "/es_ES/sectores/pagos-retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___fr_FR",
    path: "/fr_FR/secteurs/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___it_IT",
    path: "/it_IT/settori/retail-pagamenti",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___ja_JP",
    path: "/ja_JP/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___es_MX",
    path: "/es_MX/industrias/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___nl_NL",
    path: "/nl_NL/industrieen/retailbetalingen",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___no_NO",
    path: "/no_NO/bransjer/detaljhandel-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___pl_PL",
    path: "/pl_PL/branze/platnosci-w-handlu",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___pt_PT",
    path: "/pt_PT/setores/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___sv_SE",
    path: "/sv_SE/branscher/betalningar-i-detaljhandeln",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___en_AE",
    path: "/en_AE/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___en_SG",
    path: "/en_SG/industries/retail-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "industries-retail___en_GB",
    path: "/en_GB/industries/retail",
    component: () => import("/opt/build/repo/website/main/pages/industries/retail/index.vue")
  },
  {
    name: "platform-payments___en",
    path: "/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___en_AU",
    path: "/en_AU/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___pt_BR",
    path: "/pt_BR/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___zh_CN",
    path: "/zh_CN/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___cs_CZ",
    path: "/cs_CZ/platby-pro-trziste",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___da_DK",
    path: "/da_DK/markedspladser-og-platforme",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___de_DE",
    path: "/de_DE/plattformen",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___es_ES",
    path: "/es_ES/plataformas",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___fr_FR",
    path: "/fr_FR/paiements-plateformes",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___it_IT",
    path: "/it_IT/piattaforme",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___es_MX",
    path: "/es_MX/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___nl_NL",
    path: "/nl_NL/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___no_NO",
    path: "/no_NO/markedsplasser-og-plattformer",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___pl_PL",
    path: "/pl_PL/platformy-marketplace-i-handlowe",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___pt_PT",
    path: "/pt_PT/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___sv_SE",
    path: "/sv_SE/plattformar",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___en_SG",
    path: "/en_SG/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "platform-payments___en_GB",
    path: "/en_GB/platform-payments",
    component: () => import("/opt/build/repo/website/main/pages/platform-payments/index.vue")
  },
  {
    name: "industries-digital___en",
    path: "/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___en_AU",
    path: "/en_AU/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___pt_BR",
    path: "/pt_BR/setores/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___zh_CN",
    path: "/zh_CN/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___da_DK",
    path: "/da_DK/industrier/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___de_DE",
    path: "/de_DE/branchen/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___es_ES",
    path: "/es_ES/sectores/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___fr_FR",
    path: "/fr_FR/secteurs/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___it_IT",
    path: "/it_IT/settori/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___ja_JP",
    path: "/ja_JP/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___es_MX",
    path: "/es_MX/industrias/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___nl_NL",
    path: "/nl_NL/industrieen/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___no_NO",
    path: "/no_NO/bransjer/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___pl_PL",
    path: "/pl_PL/branze/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___pt_PT",
    path: "/pt_PT/setores/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___sv_SE",
    path: "/sv_SE/branscher/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___en_AE",
    path: "/en_AE/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___en_SG",
    path: "/en_SG/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "industries-digital___en_GB",
    path: "/en_GB/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital/index.vue")
  },
  {
    name: "platform-directory___en",
    path: "/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___en_AU",
    path: "/en_AU/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___da_DK",
    path: "/da_DK/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___no_NO",
    path: "/no_NO/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___sv_SE",
    path: "/sv_SE/plattformskatalog",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___en_AE",
    path: "/en_AE/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___en_SG",
    path: "/en_SG/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "platform-directory___en_GB",
    path: "/en_GB/platform-directory",
    component: () => import("/opt/build/repo/website/main/pages/platform-directory/index.vue")
  },
  {
    name: "industries-mobility___en",
    path: "/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___en_AU",
    path: "/en_AU/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___pt_BR",
    path: "/pt_BR/setores/pagamentos-mobilidade-urbana",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___zh_CN",
    path: "/zh_CN/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___da_DK",
    path: "/da_DK/industrier/mobilitet-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___de_DE",
    path: "/de_DE/branchen/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___es_ES",
    path: "/es_ES/sectores/palataforma-pagos-empresas-movilidad",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___fr_FR",
    path: "/fr_FR/secteurs/paiements-mobilite",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___it_IT",
    path: "/it_IT/settori/pagamenti-mobilita",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___ja_JP",
    path: "/ja_JP/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___es_MX",
    path: "/es_MX/industrias/mobility-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___nl_NL",
    path: "/nl_NL/industrieen/betalingen-in-de-mobiliteitsindustrie",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___no_NO",
    path: "/no_NO/bransjer/mobilitet-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___pl_PL",
    path: "/pl_PL/branze/platnosci-w-transporci",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___pt_PT",
    path: "/pt_PT/setores/mobility-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___sv_SE",
    path: "/sv_SE/branscher/betalningar-inom-transport",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___en_AE",
    path: "/en_AE/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___en_SG",
    path: "/en_SG/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-mobility___en_GB",
    path: "/en_GB/industries/mobility",
    component: () => import("/opt/build/repo/website/main/pages/industries/mobility/index.vue")
  },
  {
    name: "industries-platforms___en",
    path: "/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___en_AU",
    path: "/en_AU/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___pt_BR",
    path: "/pt_BR/setores/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___zh_CN",
    path: "/zh_CN/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___da_DK",
    path: "/da_DK/industrier/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___de_DE",
    path: "/de_DE/branchen/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___es_ES",
    path: "/es_ES/sectores/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___fr_FR",
    path: "/fr_FR/secteurs/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___it_IT",
    path: "/it_IT/settori/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___es_MX",
    path: "/es_MX/industrias/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___nl_NL",
    path: "/nl_NL/industrieen/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___no_NO",
    path: "/no_NO/bransjer/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___pl_PL",
    path: "/pl_PL/branze/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___pt_PT",
    path: "/pt_PT/setores/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___sv_SE",
    path: "/sv_SE/branscher/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___en_AE",
    path: "/en_AE/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___en_SG",
    path: "/en_SG/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "industries-platforms___en_GB",
    path: "/en_GB/industries/platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/platforms/index.vue")
  },
  {
    name: "index-reports-previous___en",
    path: "/index-reports/previous",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/previous/index.vue")
  },
  {
    name: "industries-hospitality___en",
    path: "/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___en_AU",
    path: "/en_AU/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___pt_BR",
    path: "/pt_BR/setores/pagamentos-para-hotel",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___zh_CN",
    path: "/zh_CN/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___da_DK",
    path: "/da_DK/industrier/hotelbetalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___de_DE",
    path: "/de_DE/branchen/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___es_ES",
    path: "/es_ES/sectores/pagos-en-hoteles",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___fr_FR",
    path: "/fr_FR/secteurs/paiements-hoteliers",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___it_IT",
    path: "/it_IT/settori/pagamenti-hotel",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___ja_JP",
    path: "/ja_JP/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___es_MX",
    path: "/es_MX/industrias/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___nl_NL",
    path: "/nl_NL/industrieen/hotelbetalingen",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___no_NO",
    path: "/no_NO/bransjer/hotell-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___pl_PL",
    path: "/pl_PL/branze/platnosci-w-hotelach",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___pt_PT",
    path: "/pt_PT/setores/hotel-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___sv_SE",
    path: "/sv_SE/branscher/hotellbetalningar",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___en_AE",
    path: "/en_AE/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___en_SG",
    path: "/en_SG/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-hospitality___en_GB",
    path: "/en_GB/industries/hospitality",
    component: () => import("/opt/build/repo/website/main/pages/industries/hospitality/index.vue")
  },
  {
    name: "industries-omnichannel___en",
    path: "/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___en_AU",
    path: "/en_AU/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___pt_BR",
    path: "/pt_BR/setores/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___zh_CN",
    path: "/zh_CN/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___da_DK",
    path: "/da_DK/industrier/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___de_DE",
    path: "/de_DE/branchen/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___es_ES",
    path: "/es_ES/sectores/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___fr_FR",
    path: "/fr_FR/secteurs/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___it_IT",
    path: "/it_IT/settori/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___ja_JP",
    path: "/ja_JP/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___es_MX",
    path: "/es_MX/industrias/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___nl_NL",
    path: "/nl_NL/industrieen/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___no_NO",
    path: "/no_NO/bransjer/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___pl_PL",
    path: "/pl_PL/branze/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___pt_PT",
    path: "/pt_PT/setores/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___sv_SE",
    path: "/sv_SE/branscher/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___en_AE",
    path: "/en_AE/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___en_SG",
    path: "/en_SG/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "industries-omnichannel___en_GB",
    path: "/en_GB/industries/omnichannel",
    component: () => import("/opt/build/repo/website/main/pages/industries/omnichannel/index.vue")
  },
  {
    name: "online-payments-in-app___en",
    path: "/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___en_AU",
    path: "/en_AU/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___pt_BR",
    path: "/pt_BR/pagamentos-online/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___zh_CN",
    path: "/zh_CN/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___cs_CZ",
    path: "/cs_CZ/online-platebni-brana/platby-v-aplikaci",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___da_DK",
    path: "/da_DK/online-betalinger/i-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___de_DE",
    path: "/de_DE/online-zahlungen/in-app-zahlungen",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___es_ES",
    path: "/es_ES/tpv-virtual/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___fr_FR",
    path: "/fr_FR/paiements-en-ligne/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___it_IT",
    path: "/it_IT/pagamenti-online/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___ja_JP",
    path: "/ja_JP/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___es_MX",
    path: "/es_MX/pagos-online/en-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___nl_NL",
    path: "/nl_NL/online-betalingen/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___no_NO",
    path: "/no_NO/checkout/i-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___pl_PL",
    path: "/pl_PL/platnosci-online/w-aplikacji",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___pt_PT",
    path: "/pt_PT/pagamentos-online/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___sv_SE",
    path: "/sv_SE/checkout/inuti-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___en_AE",
    path: "/en_AE/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___en_SG",
    path: "/en_SG/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "online-payments-in-app___en_GB",
    path: "/en_GB/online-payments/in-app",
    component: () => import("/opt/build/repo/website/main/pages/online-payments/in-app/index.vue")
  },
  {
    name: "industries-subscription___en",
    path: "/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___en_AU",
    path: "/en_AU/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___pt_BR",
    path: "/pt_BR/setores/assinatura",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___zh_CN",
    path: "/zh_CN/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___cs_CZ",
    path: "/cs_CZ/industries/platby-formou-predplatneho",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___da_DK",
    path: "/da_DK/industrier/abonnement",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___de_DE",
    path: "/de_DE/branchen/abo-unternehmen",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___es_ES",
    path: "/es_ES/sectores/suscripciones",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___fr_FR",
    path: "/fr_FR/secteurs/abonnement",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___it_IT",
    path: "/it_IT/settori/abbonamenti",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___ja_JP",
    path: "/ja_JP/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___es_MX",
    path: "/es_MX/industrias/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___nl_NL",
    path: "/nl_NL/industrieen/abonnement",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___no_NO",
    path: "/no_NO/bransjer/abonnement",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___pl_PL",
    path: "/pl_PL/branze/platnosci-subskrypcyjne-i-cykliczne",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___pt_PT",
    path: "/pt_PT/setores/assinatura",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___sv_SE",
    path: "/sv_SE/branscher/prenumeration",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___en_AE",
    path: "/en_AE/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___en_SG",
    path: "/en_SG/industries/subscription-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "industries-subscription___en_GB",
    path: "/en_GB/industries/subscription",
    component: () => import("/opt/build/repo/website/main/pages/industries/subscription/index.vue")
  },
  {
    name: "policies-and-disclaimer___en",
    path: "/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___en_AU",
    path: "/en_AU/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___pt_BR",
    path: "/pt_BR/politicas-e-termo-de-responsabilidade",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___zh_CN",
    path: "/zh_CN/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___cs_CZ",
    path: "/cs_CZ/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___da_DK",
    path: "/da_DK/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___de_DE",
    path: "/de_DE/richtlinien-und-haftungsausschluss",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___es_ES",
    path: "/es_ES/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___fr_FR",
    path: "/fr_FR/politiques-et-mentions-legales",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___it_IT",
    path: "/it_IT/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___ja_JP",
    path: "/ja_JP/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___es_MX",
    path: "/es_MX/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___nl_NL",
    path: "/nl_NL/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___no_NO",
    path: "/no_NO/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___pl_PL",
    path: "/pl_PL/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___pt_PT",
    path: "/pt_PT/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___sv_SE",
    path: "/sv_SE/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___en_AE",
    path: "/en_AE/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___en_SG",
    path: "/en_SG/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer___en_GB",
    path: "/en_GB/policies-and-disclaimer",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/index.vue")
  },
  {
    name: "policies-and-disclaimer-slug___en",
    path: "/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___en_AU",
    path: "/en_AU/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___pt_BR",
    path: "/pt_BR/politicas-e-termo-de-responsabilidade/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___zh_CN",
    path: "/zh_CN/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___cs_CZ",
    path: "/cs_CZ/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___da_DK",
    path: "/da_DK/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___de_DE",
    path: "/de_DE/richtlinien-und-haftungsausschluss/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___es_ES",
    path: "/es_ES/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___fr_FR",
    path: "/fr_FR/politiques-et-mentions-legales/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___it_IT",
    path: "/it_IT/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___ja_JP",
    path: "/ja_JP/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___es_MX",
    path: "/es_MX/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___nl_NL",
    path: "/nl_NL/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___no_NO",
    path: "/no_NO/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___pl_PL",
    path: "/pl_PL/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___pt_PT",
    path: "/pt_PT/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___sv_SE",
    path: "/sv_SE/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___en_AE",
    path: "/en_AE/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___en_SG",
    path: "/en_SG/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "policies-and-disclaimer-slug___en_GB",
    path: "/en_GB/policies-and-disclaimer/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/[slug].vue")
  },
  {
    name: "global-payment-processing___en",
    path: "/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___en_AU",
    path: "/en_AU/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___pt_BR",
    path: "/pt_BR/processamento-global-pagamentos",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___zh_CN",
    path: "/zh_CN/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___cs_CZ",
    path: "/cs_CZ/platebni-platforma",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___da_DK",
    path: "/da_DK/global-betalingsbehandling",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___de_DE",
    path: "/de_DE/globale-zahlungsabwicklung",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___es_ES",
    path: "/es_ES/adquirencia-medios-de-pago",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___fr_FR",
    path: "/fr_FR/traitement-mondial-des-paiements",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___it_IT",
    path: "/it_IT/acquiring-globale",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___ja_JP",
    path: "/ja_JP/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___es_MX",
    path: "/es_MX/adquirencia-medios-de-pago",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___nl_NL",
    path: "/nl_NL/wereldwijde-betaalverwerking",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___no_NO",
    path: "/no_NO/global-betalingsprosessering",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___pl_PL",
    path: "/pl_PL/globalna-bramka-platnicza",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___pt_PT",
    path: "/pt_PT/processamento-global-pagamentos",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___sv_SE",
    path: "/sv_SE/kortinlosen",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___en_AE",
    path: "/en_AE/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___en_SG",
    path: "/en_SG/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "global-payment-processing___en_GB",
    path: "/en_GB/global-payment-processing",
    component: () => import("/opt/build/repo/website/main/pages/global-payment-processing/index.vue")
  },
  {
    name: "index-reports-industry-slug___en",
    path: "/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___en_AU",
    path: "/en_AU/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___pt_BR",
    path: "/pt_BR/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___zh_CN",
    path: "/zh_CN/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___cs_CZ",
    path: "/cs_CZ/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___da_DK",
    path: "/da_DK/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___de_DE",
    path: "/de_DE/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___es_ES",
    path: "/es_ES/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___fr_FR",
    path: "/fr_FR/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___it_IT",
    path: "/it_IT/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___ja_JP",
    path: "/ja_JP/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___es_MX",
    path: "/es_MX/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___nl_NL",
    path: "/nl_NL/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___no_NO",
    path: "/no_NO/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___pl_PL",
    path: "/pl_PL/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___pt_PT",
    path: "/pt_PT/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___sv_SE",
    path: "/sv_SE/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___en_AE",
    path: "/en_AE/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___en_SG",
    path: "/en_SG/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "index-reports-industry-slug___en_GB",
    path: "/en_GB/index-reports/:industry()/:slug()",
    component: () => import("/opt/build/repo/website/main/pages/index-reports/[industry]/[slug].vue")
  },
  {
    name: "industries-saas-platforms___en",
    path: "/industries/saas-platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/saas-platforms/index.vue")
  },
  {
    name: "industries-saas-platforms___en_AU",
    path: "/en_AU/industries/saas-platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/saas-platforms/index.vue")
  },
  {
    name: "industries-saas-platforms___en_SG",
    path: "/en_SG/industries/saas-platforms",
    component: () => import("/opt/build/repo/website/main/pages/industries/saas-platforms/index.vue")
  },
  {
    name: "industries-food-and-beverage___en",
    path: "/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___en_AU",
    path: "/en_AU/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___pt_BR",
    path: "/pt_BR/setores/pagamentos-para-restaurantes",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___zh_CN",
    path: "/zh_CN/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___cs_CZ",
    path: "/cs_CZ/industries/platby-v-gastronomii",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___da_DK",
    path: "/da_DK/industrier/mad-drikkevarer-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___de_DE",
    path: "/de_DE/branchen/gastronomie-payments",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___es_ES",
    path: "/es_ES/sectores/restauracion",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___fr_FR",
    path: "/fr_FR/secteurs/paiements-restauration",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___it_IT",
    path: "/it_IT/settori/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___ja_JP",
    path: "/ja_JP/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___es_MX",
    path: "/es_MX/industrias/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___nl_NL",
    path: "/nl_NL/industrieen/horeca",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___no_NO",
    path: "/no_NO/bransjer/serveringsbransjen",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___pl_PL",
    path: "/pl_PL/branze/platnosci-gastronomia",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___pt_PT",
    path: "/pt_PT/setores/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___sv_SE",
    path: "/sv_SE/branscher/betalningar-mat-dryck",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___en_AE",
    path: "/en_AE/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___en_SG",
    path: "/en_SG/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-food-and-beverage___en_GB",
    path: "/en_GB/industries/food-and-beverage",
    component: () => import("/opt/build/repo/website/main/pages/industries/food-and-beverage/index.vue")
  },
  {
    name: "industries-digital-businesses___en",
    path: "/industries/digital-businesses",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___en_AU",
    path: "/en_AU/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___pt_BR",
    path: "/pt_BR/setores/pagamentos-digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___zh_CN",
    path: "/zh_CN/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___cs_CZ",
    path: "/cs_CZ/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___da_DK",
    path: "/da_DK/industrier/digitale-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___de_DE",
    path: "/de_DE/branchen/digitale-zahlungen",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___es_ES",
    path: "/es_ES/sectores/pagos-digitales",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___fr_FR",
    path: "/fr_FR/secteurs/paiements-digitaux",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___it_IT",
    path: "/it_IT/settori/pagamenti-digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___ja_JP",
    path: "/ja_JP/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___es_MX",
    path: "/es_MX/industrias/pagos-digitales",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___nl_NL",
    path: "/nl_NL/industrieen/digitale-betalingen",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___no_NO",
    path: "/no_NO/bransjer/digitale-betalinger",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___pl_PL",
    path: "/pl_PL/branze/platnosci-dla-digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___pt_PT",
    path: "/pt_PT/setores/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___sv_SE",
    path: "/sv_SE/branscher/digitala-betalningar",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___en_AE",
    path: "/en_AE/industries/digital-businesses",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___en_SG",
    path: "/en_SG/industries/digital-businesses",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "industries-digital-businesses___en_GB",
    path: "/en_GB/industries/digital",
    component: () => import("/opt/build/repo/website/main/pages/industries/digital-businesses/index.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___en",
    path: "/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___en_AU",
    path: "/en_AU/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___pt_BR",
    path: "/pt_BR/politicas-e-termo-de-responsabilidade/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___zh_CN",
    path: "/zh_CN/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___cs_CZ",
    path: "/cs_CZ/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___da_DK",
    path: "/da_DK/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___de_DE",
    path: "/de_DE/richtlinien-und-haftungsausschluss/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___es_ES",
    path: "/es_ES/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___fr_FR",
    path: "/fr_FR/politiques-et-mentions-legales/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___it_IT",
    path: "/it_IT/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___ja_JP",
    path: "/ja_JP/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___es_MX",
    path: "/es_MX/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___nl_NL",
    path: "/nl_NL/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___no_NO",
    path: "/no_NO/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___pl_PL",
    path: "/pl_PL/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___pt_PT",
    path: "/pt_PT/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___sv_SE",
    path: "/sv_SE/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___en_AE",
    path: "/en_AE/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___en_SG",
    path: "/en_SG/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-privacy-form___en_GB",
    path: "/en_GB/policies-and-disclaimer/privacy-form",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/privacy-form.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___en",
    path: "/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___en_AU",
    path: "/en_AU/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___pt_BR",
    path: "/pt_BR/politicas-e-termo-de-responsabilidade/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___zh_CN",
    path: "/zh_CN/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___cs_CZ",
    path: "/cs_CZ/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___da_DK",
    path: "/da_DK/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___de_DE",
    path: "/de_DE/richtlinien-und-haftungsausschluss/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___es_ES",
    path: "/es_ES/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___fr_FR",
    path: "/fr_FR/politiques-et-mentions-legales/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___it_IT",
    path: "/it_IT/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___ja_JP",
    path: "/ja_JP/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___es_MX",
    path: "/es_MX/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___nl_NL",
    path: "/nl_NL/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___no_NO",
    path: "/no_NO/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___pl_PL",
    path: "/pl_PL/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___pt_PT",
    path: "/pt_PT/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___sv_SE",
    path: "/sv_SE/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___en_AE",
    path: "/en_AE/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___en_SG",
    path: "/en_SG/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "policies-and-disclaimer-cookie-policy___en_GB",
    path: "/en_GB/policies-and-disclaimer/cookie-policy",
    component: () => import("/opt/build/repo/website/main/pages/policies-and-disclaimer/cookie-policy.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___en",
    path: "/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___en_AU",
    path: "/en_AU/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___pt_BR",
    path: "/pt_BR/terminais-pagamento/conversao-dinamica-moedas",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___da_DK",
    path: "/da_DK/pos-betalinger/dynamisk-valutakonvertering",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___de_DE",
    path: "/de_DE/pos-zahlungen/dynamische-wahrungsumrechnung",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___es_ES",
    path: "/es_ES/pagos-tpv/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___fr_FR",
    path: "/fr_FR/paiements-en-point-de-vente/conversion-dynamique-des-devises",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___it_IT",
    path: "/it_IT/pagamenti-pos/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___es_MX",
    path: "/es_MX/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___nl_NL",
    path: "/nl_NL/pos-betalingen/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___no_NO",
    path: "/no_NO/pos-betalinger/dynamisk-valutaveksling",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___pl_PL",
    path: "/pl_PL/platnosci-pos/dynamisk-valutaveksling",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___pt_PT",
    path: "/pt_PT/terminais-pagamento/conversao-dinamica-moedas",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___sv_SE",
    path: "/sv_SE/fysiska-betalningar/dynamisk-valutavaxling",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___en_AE",
    path: "/en_AE/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___en_SG",
    path: "/en_SG/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  },
  {
    name: "pos-payments-dynamic-currency-conversion___en_GB",
    path: "/en_GB/pos-payments/dynamic-currency-conversion",
    meta: indexM7Yis97LKu_71FgB6nWrdJ1lCNRAjWQlpecxh2r8YIAMeta || {},
    component: () => import("/opt/build/repo/website/main/pages/pos-payments/dynamic-currency-conversion/index.vue")
  }
]